<template>
    <div v-if="isActive" class="np-tab-content">
      <slot></slot>
    </div>
  </template>
  
  <script>
  export default {
    name: "Tab",
    props: {
      id: {
        type: String,
        required: true
      }
    },
    inject: ["activeTab"], 
    watch: {
        activeTab(newVal) {
            console.log("Активный таб обновлен:", newVal);
        }
    },    
    computed: {
      isActive() {
        console.log("Проверка активности таба:", this.activeTab);
        return this.activeTab === this.id
      }
    }
  }
  </script>
  
  <style scoped>
  </style>